import { Box, Stack } from '@mui/material';
import { FC } from 'react';
import { useGetOne } from 'react-admin';

import { GetInstrumentsResponseItem } from '@Common/types/bo/instruments';

import { B2bInvestorProfileGridColumnHeader } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileGrid/components/B2bInvestorProfileGridColumn/components/B2bInvestorProfileGridColumnHeader/B2bInvestorProfileGridColumnHeader';
import { InvestorProfileGridInstrumentAllocation } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileGrid/helpers/transformBoGridToFormGrid';

interface Props {
  allocation: InvestorProfileGridInstrumentAllocation;
}

export const B2bInvestorProfileShowGridColumn: FC<Props> = (props) => {
  const { allocation } = props;

  const { data: instrument } = useGetOne<GetInstrumentsResponseItem>('instruments', {
    id: allocation.instrument_id,
  });

  if (!instrument) {
    return null;
  }

  return (
    <Stack spacing={1.45}>
      <B2bInvestorProfileGridColumnHeader
        instrumentName={instrument.name ?? ''}
        instrumentIsin={instrument.isin ?? ''}
      />
      {allocation.allocation.map((value, rowIdx) => (
        <Box key={rowIdx} height={58} width={130} alignContent="center">
          <span>{`${value}%`}</span>
        </Box>
      ))}
    </Stack>
  );
};
